import { defineStore } from 'pinia';

let _id = 0;

// Lightweight global toast/notification store. Use from anywhere:
//   import { useToastStore } from '@/stores/toast';
//   useToastStore().success('Saved'); useToastStore().error('Could not save');
export const useToastStore = defineStore('toast', {
  state: () => ({ toasts: [] }),
  actions: {
    push(message, type = 'info', timeout = 4000) {
      const id = ++_id;
      this.toasts.push({ id, message, type });
      if (timeout) setTimeout(() => this.dismiss(id), timeout);
      return id;
    },
    success(m, t = 3500) { return this.push(m, 'success', t); },
    error(m, t = 6000) { return this.push(m, 'error', t); },
    info(m, t = 4000) { return this.push(m, 'info', t); },
    dismiss(id) { this.toasts = this.toasts.filter((x) => x.id !== id); },
  },
});
